"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitReferralApiPayloadSchema = exports.getReferralProgramApiResponseSchema = exports.referralSummarySchema = exports.filleulSchema = exports.referralInstallationBonusSchema = exports.referralInstallationBonusKeySchema = exports.referralTierSchema = exports.referralTierKeySchema = exports.PROSPECT_STATUSES = exports.prospectStatusSchema = void 0;
const zod_1 = require("zod");
/** Mirrors the backend `ProspectStatus` enum. */
exports.prospectStatusSchema = zod_1.z.enum([
    'contacted',
    'in_discussion',
    'installed',
    'refused',
    'lost',
    'duplicate',
]);
/** Every funnel stage, in funnel order — for filter dropdowns and labels. */
exports.PROSPECT_STATUSES = exports.prospectStatusSchema.options;
exports.referralTierKeySchema = zod_1.z.enum(['argent', 'or', 'platine']);
exports.referralTierSchema = zod_1.z.object({
    key: exports.referralTierKeySchema,
    minInstallations: zod_1.z.number(),
    primePerFilleul: zod_1.z.number(),
});
/** Mirrors the backend `ReferralInstallationBonusKey` union. */
exports.referralInstallationBonusKeySchema = zod_1.z.enum([
    'existing_office',
    'new_office',
]);
exports.referralInstallationBonusSchema = zod_1.z.object({
    key: exports.referralInstallationBonusKeySchema,
    amount: zod_1.z.number(),
});
exports.filleulSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    city: zod_1.z.string(),
    /** Serialized by the API with `toISOString()`. */
    submittedAt: zod_1.z.string().datetime(),
    status: exports.prospectStatusSchema,
});
exports.referralSummarySchema = zod_1.z.object({
    contactedCount: zod_1.z.number(),
    discussionCount: zod_1.z.number(),
    installedCount: zod_1.z.number(),
    notRetainedCount: zod_1.z.number(),
    /** Null until a first filleul installs — the ladder has no entry rung. */
    tier: exports.referralTierSchema.nullable(),
    nextTier: exports.referralTierSchema.nullable(),
    remainingToNextTier: zod_1.z.number(),
    primeEarned: zod_1.z.number(),
});
exports.getReferralProgramApiResponseSchema = zod_1.z.object({
    summary: exports.referralSummarySchema,
    filleuls: zod_1.z.array(exports.filleulSchema),
    /** The tier ladder as the backend defines it — never hardcode amounts client-side. */
    tiers: zod_1.z.array(exports.referralTierSchema),
    /** The flat titularisation bonuses, same rule: the backend owns the amounts. */
    installationBonuses: zod_1.z.array(exports.referralInstallationBonusSchema),
});
/**
 * Body of `POST /referrals`.
 *
 * The bounds mirror `SubmitReferralRequestDto` on the API side, which is what
 * actually enforces them; keeping them here lets the client fail before the
 * round-trip rather than after it.
 */
exports.submitReferralApiPayloadSchema = zod_1.z.object({
    firstName: zod_1.z.string().trim().min(1).max(120),
    lastName: zod_1.z.string().trim().min(1).max(120),
    email: zod_1.z.string().trim().email().max(120),
    phone: zod_1.z.string().trim().min(1).max(30).optional(),
    desiredCity: zod_1.z.string().trim().min(1).max(120),
    message: zod_1.z.string().trim().min(1).max(2000).optional(),
});
